<template>
	<div>
		<div class="main">
			<form>
				<div class="w-full flex justify-start flex-col">
					<div class="flex flex-col w-full pr-0 md:pr-4 gap-x-8 xl:gap-x-24 gap-y-4 border-b-2 pb-5 mb-5">
						<div class="m-4" v-if="!this.isLoading && this.documents && this.documents.length <= 0"><b>Keine freigebenen Dokumente verfügbar</b></div>
						<BaseSelect
							class="w-1/3 cursor-pointer mb-0"
							v-if="documents"
							ref="documents"
							label="Verfügbare Dokumente"
							:options="documents"
							v-model="selectedDocument"
							track-by="uuid"
							options-label="label"
							:required="false"
							:multiple="false"
						/>
					</div>
					<div class="flex grid grid-cols-3 justify-start ">
						<div class="flex" style="align-self: center">
							{{ $t('document_not_available') }}
						</div>

						<div class="flex">
							<BaseButton class="btn-blue">{{ $t('share_document') }}</BaseButton>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import { PdfApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Validate from '@/mixins/Validate';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import { getStringFromDate } from '@/plugins/Utils';

export default {
	name: 'ChatDocumentsModal',
	components: { BaseSelect, BaseButton },
	mixins: [Validate],
	data() {
		return {
			isLoading: true,
			vehicleID: null,
			documents: [],
			selectedDocument: null,
		};
	},
	methods: {
		save() {},
		getVehicleDocuments() {
			this.isLoading = true;
			if (this.vehicleID != null) {
				PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.pdfVehiclesIdGet(this.vehicleID)
					.then(response => {
						response.data.data.map(option => {
							if (option.uuid !== null) {
								option.value = option.uuid;
								option.display = option.label + ` (${this.$t('damage_case_from')} ${getStringFromDate(option.date_of_accident)})`;
								this.documents.push(option);
							}
						});
						this.isLoading = false;
					});
			}
		},
	},
	mounted() {
		this.isLoading = true;
		this.vehicleID = this.$route.params.vehicleid;
		this.getVehicleDocuments();
	},
};
</script>

<style scoped></style>
